<template>
    <div class="col-12">
        <div class="scroll-table">
            <div class="table-responsive text-nowrap">
                <table class="table table-striped">
                    <thead>
                    <tr>
                        <th class="th-first"><input :checked="isAllChecked" style="z-index: 1;" type="checkbox"
                                                    @change="checkAll"></th>
                        <th>{{ __('document_date') }}</th>
                        <th>{{ __('document_type') }}</th>
                        <th>{{ __('document_nr') }}</th>
                        <th>{{ __('correction_document_nr') }}</th>
                        <th class="text-right">{{ __('document_net_amount') }}</th>
                        <th class="text-right">{{ __('document_gross_amount') }}</th>
                        <th class="text-right">{{ __('advance_payment_for_net_settlement') }}</th>
                        <th class="text-right">{{ __('advance_payment_for_gross_settlement') }}</th>
                        <th class="th-before th-last text-right"></th>
                    </tr>
                    </thead>
                    <tbody v-if="hasDocuments">
                    <ContractDocumentTableRow
                        v-for="(document, index) in documents"
                        :key="document.id"
                        :checked="isChecked(document.id)"
                        :document="document"
                        :index="index"
                        :relatedDocumentTypes="relatedDocumentTypes"
                        @checked="changeChecked"
                    />
                    </tbody>
                    <tbody v-else>
                    <tr class="row-show row-one-line row-odd">
                        <td class="text-center" colspan="10">{{ __('no_documents_in_the_contract') }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <slot :checkedDocuments="checkedDocuments"/>
        </div>
    </div>
</template>

<script>
import ContractDocumentRow from "./ContractDocumentTableRow";
import ContractDocumentTableRow from "./ContractDocumentTableRow";

export default {
    name: "ContractDocumentsTable",
    components: {ContractDocumentTableRow, ContractDocumentRow},
    props: {
        documents: {
            type: Array,
            required: true,
        },
        relatedDocumentTypes: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            checkedDocuments: [],
        };
    },
    computed: {
        hasDocuments() {
            return this.documents.length > 0;
        },
        isAllChecked() {
            return this.hasDocuments && this.documents.length === this.checkedDocuments.length;
        },
    },
    methods: {
        isChecked(id) {
            return this.checkedDocuments.includes(id);
        },
        checkAll(event) {
            if (event.target.checked) {
                this.checkedDocuments = this.documents.filter(document => this.relatedDocumentTypes.includes(document.document_type)).map((document => document.id));
            } else {
                this.checkedDocuments = [];
            }
        },
        changeChecked({value, checked}) {
            if (checked) this.checkedDocuments.push(value);
            else {
                this.checkedDocuments.splice(this.checkedDocuments.indexOf(value), 1);
            }
        },
    },
};
</script>
